import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import PublicSafetyDetails from '../mendepartmentdetails/PublicSafety'


function PublicSafety() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Public Safety || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Public Safety"
            subtitledown="Department of Public Safety"
           />
            <PublicSafetyDetails/>
        </div>
    </>
  )
}

export default PublicSafety